export default {
  errors: null,
  name: null,
  email: null,
  phone: null,
  city_id: null,
  message: null,
  pending: false
}
